import moment from "moment";
import { DATE_FORMAT } from "Constants";

export function arrangeDataWeekly(data) {
  var weeks = [
    { name: "MON", hits: 0 },
    { name: "TUE", hits: 0 },
    { name: "WED", hits: 0 },
    { name: "THU", hits: 0 },
    { name: "FRI", hits: 0 },
    { name: "SAT", hits: 0 },
    { name: "SUN", hits: 0 },
  ];

  var weeksWithData = [];
  weeks.map((week, weekindex) => {
    var weekHitsCount = 0;
    data.map((value, index) => {
      var weekDay = moment(value.time).isoWeekday();
      if (weekDay === 7 && weekindex === 6) {
        //Sunday
        weekHitsCount++;
      } else if (weekDay - 1 === weekindex) {
        weekHitsCount++;
      }
    });
    weeksWithData.push({ ...week, hits: weekHitsCount, amt: data.length });
  });
  return weeksWithData;
}

export var arrangeDataMonthly = (data) => {
  var months = [
    { name: "JAN", hits: 0 },
    { name: "FEB", hits: 0 },
    { name: "MAR", hits: 0 },
    { name: "APR", hits: 0 },
    { name: "MAY", hits: 0 },
    { name: "JUN", hits: 0 },
    { name: "JUL", hits: 0 },
    { name: "AUG", hits: 0 },
    { name: "SEP", hits: 0 },
    { name: "OCT", hits: 0 },
    { name: "NOV", hits: 0 },
    { name: "DEC", hits: 0 },
  ];

  var monthsWithData = [];
  var curYear = moment().year();
  months.map((month, monthindex) => {
    var monthHitsCount = 0;
    data.map((value, index) => {
      var dateYear = moment(value.time).year();

      // if(curYear === dateYear){//If data belongs to same year
      var monthDay = moment(value.time).month();
      // if((monthDay-1) === monthindex){
      if (monthDay === monthindex) {
        monthHitsCount++;
      }
      // }
    });
    monthsWithData.push({ ...month, hits: monthHitsCount, amt: data.length });
  });

  return monthsWithData;
};

export var arrangeDataDateWise = (data, dateObj) => {
  // console.log("data :- ", data);
  // console.log("dateObj :- ", dateObj);

  let workingDate = [];
  let selectedDate = [];
  let start = new Date(dateObj.from);
  let end = new Date(dateObj.to);
  let loop = new Date(start);
  while (loop <= end) {
    // console.log(loop);
    // console.log(moment(loop).format(DATE_FORMAT));
    workingDate.push(moment(loop).format(DATE_FORMAT));
    let month = loop.getMonth() + 1;
    selectedDate.push({
      name: loop.getDate() + "/" + month,
      hits: 0,
    });

    let newDate = loop.setDate(loop.getDate() + 1);
    loop = new Date(newDate);
  }

  var dateWithData = [];
  workingDate.map((date, index) => {
    // console.log("date :- ", date);
    let match = data.filter((obj) => {
      return moment(obj.time).format(DATE_FORMAT) == date;
    });

    dateWithData.push({
      name: selectedDate[index].name,
      hits: match.length,
      amt: data.length,
    });
  });

  // console.log("dateWithData :- ", dateWithData);
  return dateWithData;
};
